export const homeType = 'smart-mobility-home-page'
